import axiosInstance from "@lib/axios";
import { UpDateDeviceInfoType } from "..";
import { AxiosResponse } from "axios";

export const updateDeviceInfo = async (info: UpDateDeviceInfoType) => {
    const { data }: AxiosResponse<{ worker_count: number }> = await axiosInstance.post("/device/info", info);

    return data;
};
